import resolveFeatureFlag from './resolveFeatureFlag';

/**
 * Contributor tasks at `/tasks`. Default off, so the rest of the app is unchanged
 * until LaunchDarkly `workflowTasks` is turned on.
 *
 *   localStorage.setItem('workflowTasks', 'true')
 *   localStorage.removeItem('workflowTasks')
 */
export const isWorkflowTasksEnabled = (flags?: { workflowTasks?: boolean }): boolean =>
  resolveFeatureFlag('workflowTasks', flags?.workflowTasks, false);

export default isWorkflowTasksEnabled;
